import Crud from '../views/Priority/Crud'
import Entity from '../views/Priority/Add'


let routes = {
    path: '/priorities',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/priorities/add',
            name: 'NewPriority',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de prioridades',
                breadcrumb: [
                    {
                        text: 'Tipos de prioridades',
                        active: false,
                        to: '/priorities',
                    },
                    {
                        text: 'Adicionar tipo de prioridades',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/priorities/edit/:id?',
            name: 'EditPriority',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de prioridades',
                breadcrumb: [
                    {
                        text: 'Tipos de prioridades',
                        active: false,
                        to: '/priorities',
                    },
                    {
                        text: 'Editar tipo de prioridades',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/priorities',
            name: 'list-priorities',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de prioridades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
